import { NgModule } from '@angular/core';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard, DetectableRoutes } from 'ws-framework';

const routes: DetectableRoutes = [
	{
		path: 'login',
		loadChildren: () => import('./auth/login/login.module').then((m) => m.LoginModule),
		hideInMain: true,
	},
	{
		path: '',
		loadChildren: () => import('./stage.module').then((m) => m.StageModule),
		canActivate: [AuthGuard],
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: PreloadAllModules,
			onSameUrlNavigation: 'reload',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
